<template>
  <div  class="ALL2">
    <el-menu :collapse="isCollapse" :collapse-transition="false" router background-color="#F8F9FA" text-color="#4A4A4A"
      active-text-color="#2E2E2E" :default-active="activeMenu" @select="handleSelect" style="width: 230px;">

      <!-- 一级菜单 -->
      <el-submenu v-for="item in filteredMenuList" :key="item.id" :index="String(item.path || item.authorName)"
        v-model="openedMenus">
        <template slot="title">
          <router-link v-if="item.path != null" :to="item.path">
            <i :class="iconObj[item.id]" class="menu-icon"></i>
            <span class="menu-item-text" >{{ item.authorName }}</span>
          </router-link>
          <div v-else>
            <i :class="iconObj[item.id]" class="menu-icon"></i>
            <span class="menu-item-text">{{ item.authorName }}</span>
          </div>
        </template>

        <el-menu-item-group v-for="subItem in item.children" :key="subItem.id">
          <template v-if="subItem.children && subItem.children.length > 0">
            <!-- 包含子菜单的二级菜单 -->
            <el-submenu :index="String(subItem.path)" v-model="openedMenus">
              <template slot="title">
                <i :class="iconObj[subItem.id]" class="menu-icon"></i>
                <span>{{ subItem.authorName }}</span>
              </template>
              <el-menu-item :index="String(subSubItem.path)" v-for="subSubItem in subItem.children" :key="subSubItem.id">
                <router-link :to="subSubItem.path" style="text-decoration: none; color: inherit;">
                  <i :class="iconObj[subSubItem.id]" class="menu-icon"></i>
                  <span>{{ subSubItem.authorName }}</span>
                </router-link>
              </el-menu-item>
            </el-submenu>
          </template>
          <template v-else>
            <!-- 没有子菜单的二级菜单 -->
            <el-menu-item :index="String(subItem.path)" :key="subItem.id">
              <router-link :to="subItem.path" style="text-decoration: none; color: inherit;">
                <i :class="iconObj[subItem.id]" class="menu-icon"></i>
                <span>{{ subItem.authorName }}</span>
              </router-link>
            </el-menu-item>
          </template>
        </el-menu-item-group>
      </el-submenu>

    </el-menu>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import rolePermissions from "@/router/permissions"; // 导入权限配置

export default {
  data() {
    return {
      openedMenus: ['1'],
      activeMenu: this.$route.path,  // 动态设置默认选中的菜单
      menulist: [
        {
          authorName: "我的课程",
          path: null,
          children: [
            { authorName: "课程图谱", path: "/relation/stu_coneptmap", id: 3 },
            { authorName: "课程资源", path: "/relation/stu_knowledgedisplay", id: 4 },
          ],
          id: 1,
        },
        {
          authorName: "我的测评",
          path: null,
          children: [
            { authorName: "我的考试", path: "/ques/index", id: 5 },
            { authorName: "我的报告", path: "/ques/result", id: 6 },
          ],
          id: 2,
        }
      ],
      iconObj: {
        1: "el-icon-s-management",
        2: "el-icon-s-promotion",
      },
    };
  },
  created() {
    this.openedMenus = ['1']; // 确保“我的课程”默认展开
    this.activeMenu = this.$route.path; // 确保根据路由初始化; 
    this.getMenuList();
  },
  methods: {
    getMenuList() { },
    handleSelect(val) {
    this.$nextTick(() => {
      this.activeMenu = val;  // 确保更新 activeMenu 在导航后
      // 更新展开的父菜单
      const parentMenu = this.menulist.find(item =>
        item.children && item.children.some(child => child.path === val)
      );
      if (parentMenu) {
        this.openedMenus = [String(parentMenu.id)];
      }
    });
  },
    // 获取当前用户角色
    userRole() {
      return window.sessionStorage.getItem('userRole'); // 默认返回 'teacher'
    },
    getDefaultActiveMenu() {
      // 根据 userRole 设置默认的 activeMenu
      return this.userRole === 2 ? '/relation/stu_coneptmap' : '/capacity/capManage';
    },
  },
  computed: {
    ...mapGetters(["isCollapse"]),
    // 筛选符合权限的菜单项
    filteredMenuList() {
      const userRole = window.sessionStorage.getItem('userRole');
      console.log(userRole, "打印打印打印");
      const allowedPaths = rolePermissions[userRole] || [];  // 根据角色动态获取权限

      // 递归过滤符合权限的菜单项
      const filterMenuItems = (items) => {
        return items
          .filter(item => {
            // 如果菜单项本身的路径符合权限，或者有子菜单且有符合权限的子菜单路径
            const isAllowed =
              allowedPaths.includes(item.path) ||
              (item.children && item.children.some(child => allowedPaths.includes(child.path)));

            // 如果菜单项没有路径（如二级菜单），需要检查其子菜单中是否有符合权限的路径
            if (item.path === null && item.children) {
              // 确保父菜单显示时，至少有一个子菜单符合权限
              const childrenAllowed = item.children.some(child => allowedPaths.includes(child.path) || (child.children && child.children.some(subChild => allowedPaths.includes(subChild.path))));
              return childrenAllowed;
            }
            return isAllowed;
          })
          .map(item => ({
            ...item,
            children: item.children ? filterMenuItems(item.children) : [],  // 递归处理子菜单
          }));
      };

      return filterMenuItems(this.menulist);
    },
  },
};
</script>
  
<style lang="less" scoped>
.ALL2 {
  height: 100vh; 
  display: flex;
  overflow: hidden; 
  background-color: #FAFAFA;
}


.ALL2 .el-menu {
  height: 100%;
  background-color: #F8F9FA; 
  overflow: hidden; 
  border-right: 1px solid #E0E0E0; 
}

.ALL2 .el-menu-item,
.ALL2 .el-submenu__title {
  color: #4A4A4A; /* 菜单文字颜色 */
  font-size: 16px ;
  font-family: 'Roboto', sans-serif;
  transition: all 0.3s ease;
}
.menu-item-text {
  font-size: 16px !important;
}
/* 修改图标样式 */
.menu-icon {
  color: #2a38d6 !important; 
  font-size: 20px; 
  margin-right: 15px; 
  transition: transform 0.3s ease, color 0.3s ease; 
}

/* 鼠标悬停时图标变大，颜色变深 */
.el-menu-item:hover .menu-icon,
.el-submenu__title:hover .menu-icon {
  transform: scale(1.2); 
  color: #2113e7; 
}
.el-menu-item:hover,
.el-submenu__title:hover {
  background: #ECEFF1 !important; 
  color: #333 !important; 
  box-shadow: inset 2px 0 0 #9E9E9E; 
}
.el-menu-item {
  width: 230px;
  padding-left: 30px;
}

.el-submenu {
  width: 230px;
}

.el-submenu__title {
  background-color: #F8F9FA; 
  padding: 10px 20px;
  border-radius: 4px;
}

/* 二级菜单缩进 */
.el-menu-item-group {
  padding-left: 20px;
}

.el-submenu__title {
  padding-left: 40px;
}

.el-menu-item {
  background-color: #F8F9FA; 
}

.el-menu-item:focus,
.el-menu-item.is-active {
  background-color: #E0E0E0 !important; 
  color: #333 !important; 
}

.el-submenu__title:focus,
.el-submenu.is-active .el-submenu__title {
  background-color: #E0E0E0 !important; 
  color: #333 !important;
}

.ALL2 {
  caret-color: transparent;
}
</style>
